<template>
  <v-select
    id="language-control"
    class="language-control"
    v-model="selectedLanguage"
    density="compact"
    variant="outlined"
    hide-details
    :items="languages"
    :item-value="item => item.code"
    :item-title="item => item.name"
    :menu-props="{ scrollStrategy: 'none' }"
  >
  </v-select>
</template>

<script>
import languages from "@/utils/languages"

export default {
  name: "LanguageSelect",
  data() {
    return {
      // languages.supported has one entry per supported country, so the
      // same language (e.g. "en" for both "us" and "uk") appears more than
      // once. Keep only the first entry per language code for the dropdown.
      languages: languages.supported.filter(
        (lang, index, all) => all.findIndex(l => l.code === lang.code) === index
      )
    }
  },
  computed: {
    selectedLanguage: {
      get: function() {
        return this.$store.getters.langCode
      },
      // setter
      set: function(newValue) {
        this.$root.setLanguage(newValue)
        if (this.$route.name !== "login") {
          window.location.reload()
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
.language-control {
  max-width: 170px;
}
</style>
